import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDate, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { UserId } from '../../../../types';
import { UserSummaryDto } from '../../../users/user-summary.dto';
import { PropertyModerationStatus } from './property-enums';

export class PropertyModerationEntryDto {
  @IsOptional()
  @IsString()
  _id?: string;

  @IsString()
  field!: string;

  @IsString()
  rawValue!: string;

  @IsArray()
  @IsString({ each: true })
  reasons!: string[];

  @IsEnum(PropertyModerationStatus)
  @IsOptional()
  status: PropertyModerationStatus = PropertyModerationStatus.TODO;

  @IsDate()
  @Type(() => Date)
  flaggedAt: Date = new Date();

  @IsDate()
  @Type(() => Date)
  @IsOptional()
  reviewedAt?: Date;

  @IsOptional()
  @Type(() => UserSummaryDto)
  reviewedBy?: UserId | UserSummaryDto;

  @IsString()
  @IsOptional()
  reviewNote?: string;
}

export class PropertyModerationDto {
  @IsBoolean()
  @IsOptional()
  hasContactFlag?: boolean;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => PropertyModerationEntryDto)
  @IsOptional()
  history: PropertyModerationEntryDto[] = [];
}

export class PatchPropertyModerationEntryStatusDto {
  @IsEnum(PropertyModerationStatus)
  status!: PropertyModerationStatus;

  @IsString()
  @IsOptional()
  note?: string;
}
